import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  private _baseUrlCached = null;
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.includes('googleapis.com')) {
      return next.handle(req);
    }
    if (this._baseUrlCached == null) {
      this._baseUrlCached = document.getElementsByTagName('base')[0].href;
      this._baseUrlCached = this._baseUrlCached.replace(/\/$/, '');
    }
    const baseUrl = this._baseUrlCached;
    const url = req.url.replace(/^\//, '');
    const apiReq = req.clone({ url: `${baseUrl}/${url}` });
    return next.handle(apiReq);
  }
}
